import { render, staticRenderFns } from "./bookmarks.vue?vue&type=template&id=b7a0dcdc&scoped=true"
import script from "./bookmarks.vue?vue&type=script&lang=js"
export * from "./bookmarks.vue?vue&type=script&lang=js"
import style0 from "./bookmarks.vue?vue&type=style&index=0&id=b7a0dcdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a0dcdc",
  null
  
)

export default component.exports